module.exports = __webpack_public_path__ + "fonts/AntykwaTorunska-Italic.e856842c.ttf";